import { render, staticRenderFns } from "./page-fault.vue?vue&type=template&id=3c60aed4&scoped=true&"
import script from "./page-fault.vue?vue&type=script&lang=js&"
export * from "./page-fault.vue?vue&type=script&lang=js&"
import style0 from "./page-fault.vue?vue&type=style&index=0&id=3c60aed4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60aed4",
  null
  
)

export default component.exports